@import '../../../../constants/spacing.module.less';

.header-content {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.premium-programs {
  display: flex;
  align-items: center;
  gap: @space-4;
}
